import React, { useEffect, useState } from 'react';
import { Container } from 'react-bootstrap';
import Slider from '../../Components/Slider/Slider';
import {
    fetchTrendingMovies,
    fetchTopRatedMovies,
    fetchMoviesByGenre,
    fetchPopularTVShows,
    fetchTopRatedTVShows
} from '../../Api/Moviesapi';
import './Home.css';
import { ErrorState, LoadingState } from '../../Components/PageState/PageState';

const Home = () => {
    const [trendingMovies, setTrendingMovies] = useState([]);
    const [topRatedMovies, setTopRatedMovies] = useState([]);
    const [actionMovies, setActionMovies] = useState([]);
    const [popularTV, setPopularTV] = useState([]);
    const [topTV, setTopTV] = useState([]);
    const [status, setStatus] = useState({ loading: true, error: '' });

    useEffect(() => {
        const load = async () => {
            try {
              const [trending, top, action, tv, topTvShows] = await Promise.all([fetchTrendingMovies(), fetchTopRatedMovies(), fetchMoviesByGenre(28), fetchPopularTVShows(), fetchTopRatedTVShows()]);
              setTrendingMovies(trending); setTopRatedMovies(top); setActionMovies(action); setPopularTV(tv); setTopTV(topTvShows);
              setStatus({ loading: false, error: '' });
            } catch (error) { setStatus({ loading: false, error: error.message }); }
        };
        load();
    }, []);

    if (status.loading) return <LoadingState label="Loading recommendations…" />;
    if (status.error) return <ErrorState message={status.error} />;
    return (
        <Container fluid style={{ margin: 0, padding: 0, backgroundColor: '#111' }}>
            <Slider title="Trending Movies" movies={trendingMovies} />
            <Slider title="Top Rated Movies" movies={topRatedMovies} />
            <Slider title="Action Movies" movies={actionMovies} />
            <Slider title="Popular TV Shows" movies={popularTV} />
            <Slider title="Top Rated TV Shows" movies={topTV} />
        </Container>
    );
};

export default Home;
